const JS_TEMPLATE = 'js-template';

class CustomElement extends HTMLElement {
    constructor(param) {
        super();
    }

    static get observedAttributes() { 
        return ['js-update', 'js-change']; 
    }
    
    template() {}

    callback(element = false) {
        this.element = element ? element : this.childNodes[1];
        if(!this.element) console.warn(this, `You need at least a js-template or a child element inside your ${this.tagName} element`);
    }

    removeAttributes() {
        [...this.attributes].forEach(attribute => {
            this.removeAttribute(attribute.name);
        });
    }

    connectedCallback() {
        const showTemplate = this.hasAttribute(JS_TEMPLATE);
        if(showTemplate) this.innerHTML = this.template();
        if(this.childNodes[3]) console.warn(this, 'A custom element can only have 1 child element');
        this.callback();
        this.removeAttributes();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        console.warn(this, `${name}="${newValue}" isn't triggering anything. Make sure you've added a attributeChangedCallback function.`);
    }
}
export default CustomElement;